import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LugaresService } from '../services/lugares.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DetalleComponent {

	lugares = null;
	id = null;
	elLugar:any={};

  constructor(private route: ActivatedRoute, private LugaresService: LugaresService){ 
  	console.log(this.route.snapshot.params['id']);
  	//console.log(this.route.snapshot.queryParams['action']);

 this.id = this.route.snapshot.params['id'];
    if(this.id != 'new'){
      this.LugaresService.getLugar(this.id)
        .valueChanges().subscribe((lugar)=> {
          this.elLugar = lugar;
      })
    }
  }
}


// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/detalle/detalle.component.ts